/**
 * ShareRiskSheet — s119 P1 (his rulings 2026-10-24; canvas "Orella Share Code Approval", approved incl. en + es).
 * Before the patient sends the share link (or copies the code) through their own e-mail or text: those channels
 * are not private, so the patient ticks "I understand" first. Shown every time; it never blocks the PDF share
 * (that is the patient's own file, with its own disclaimer — his ruling).
 */
import { useState } from 'react'
import { Lock, ShieldCheck, Clock } from 'lucide-react'
import { OverlayPortal } from '../ModalPortal'

const NAVY = '#15354F'

export default function ShareRiskSheet({ open, t, onCancel, onConfirm, confirmLabel }) {
  const [ok, setOk] = useState(false)
  if (!open) return null
  const close = () => { setOk(false); onCancel() }
  const go = () => { if (!ok) return; setOk(false); onConfirm() }
  return (
    <OverlayPortal>
      <div className="fixed inset-0 z-[90]" data-share-risk-sheet="">
        <button type="button" aria-label={t('shareApproval.cancel')} onClick={close} className="absolute inset-0 w-full h-full bg-[rgba(15,23,42,0.45)] border-0" />
        <section role="dialog" aria-modal="true" aria-labelledby="share-risk-title"
          className="absolute left-0 right-0 bottom-0 bg-white rounded-t-3xl px-5 pt-3 flex flex-col gap-4"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 24px)' }}>
          <span aria-hidden="true" className="self-center w-10 h-[5px] rounded bg-[#DCE6EE]" />
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-xl grid place-items-center bg-[#FFF4E5] text-[#9A5B00]"><Lock className="w-[22px] h-[22px]" aria-hidden="true" /></span>
            <h2 id="share-risk-title" className="m-0 text-xl font-extrabold" style={{ color: NAVY }}>{t('shareApproval.warnTitle')}</h2>
          </div>
          <p className="m-0 text-base leading-normal font-semibold" style={{ color: NAVY }}>{t('shareApproval.warnBody')}</p>
          <div className="flex flex-col gap-2.5 text-[15px] leading-snug text-slate-700">
            <div className="flex gap-2.5"><ShieldCheck className="w-[18px] h-[18px] flex-none mt-0.5 text-[#1E6FB8]" aria-hidden="true" /><span>{t('shareApproval.warnAllow')}</span></div>
            <div className="flex gap-2.5"><Clock className="w-[18px] h-[18px] flex-none mt-0.5 text-[#1E6FB8]" aria-hidden="true" /><span>{t('shareApproval.warnExpiry')}</span></div>
          </div>
          <label className="flex items-center gap-3 min-h-[52px] px-3.5 rounded-2xl border-[1.5px] border-[#46A8F9] bg-[#EFF8FF] text-base font-bold" style={{ color: NAVY }}>
            <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="w-[22px] h-[22px]" style={{ accentColor: NAVY }} />
            {t('shareApproval.warnCheck')}
          </label>
          <div className="grid grid-cols-2 gap-2.5">
            <button type="button" onClick={close} className="h-[52px] rounded-full border border-slate-300 bg-white font-bold text-base text-slate-700">{t('shareApproval.cancel')}</button>
            <button type="button" onClick={go} disabled={!ok} className="h-[52px] rounded-full text-white font-bold text-base disabled:opacity-50" style={{ background: NAVY }} data-cta="share-risk-confirm">{confirmLabel}</button>
          </div>
        </section>
      </div>
    </OverlayPortal>
  )
}
